<footer class="bg-dark text-white text-center py-4 mt-5">
  <div class="container">
    <p class="mb-1">© {new Date().getFullYear()} I Gusti Agung Mahendra Putra</p>
    <p class="mb-0">Email: <a href="mailto:info@kalender-bali.id" class="text-white">info@kalender-bali.id</a></p>
  </div>
</footer>
